import { render } from "./WhyUs.vue?vue&type=template&id=86887696&scoped=true"
import script from "./WhyUs.vue?vue&type=script&lang=js"
export * from "./WhyUs.vue?vue&type=script&lang=js"

import "./WhyUs.vue?vue&type=style&index=0&id=86887696&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86887696"]])

export default __exports__